"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = require("../constants");
var stores_1 = require("../stores");
function getGlobalDisclaimerStore() {
    return window[constants_1.GLOBAL_DISCLAIMER_STORE_WINDOW_KEY];
}
exports.getGlobalDisclaimerStore = getGlobalDisclaimerStore;
function initializeGlobalDisclaimers() {
    var globalDisclaimerStore = getGlobalDisclaimerStore();
    if (!globalDisclaimerStore) {
        window[constants_1.GLOBAL_DISCLAIMER_STORE_WINDOW_KEY] = new stores_1.GlobalDisclaimerStore();
    }
}
exports.initializeGlobalDisclaimers = initializeGlobalDisclaimers;
//# sourceMappingURL=globalDisclaimers.js.map